import { gql } from '@apollo/client';

export const GET_CURRENT_TARIFF = gql`
  query getCurrentTariff($input: GetCurrentTariff!) {
    getCurrentTariff(input: $input) {
      id
      title
      cost
      has_fixed_finish_time
    }
  }
`;
